global.initBikeRadarChart = function (ctx, data) {
    initRadarChart(ctx, data, ['Puissance', 'Maniabilité', 'Chemins', 'Autonomie', 'Finitions', 'Confort'])
};

global.initEasyChallengeCharacterRadarChart = function (ctx, data, labels) {
    initRadarChart(ctx, data, labels || ['Vitesse', 'Témérité', 'Réflexes', 'Connaissance', 'Agilité', 'Endurance'])
};

global.initSegmentChart = function (ctx, data) {
    new Chart(ctx, {
        type: 'line',
        data: {
            labels: data,
            datasets: [{
                data: data,
                backgroundColor: 'rgba(90, 208, 96, 0.5)',
                borderColor: '#5AD060',
                borderWidth: 5,
                fill: 'start'
            }]
        },
        options: {
            legend: false,
            tooltips: false,
            elements: {
                point: {
                    radius: 0
                }
            },
            scales: {
                yAxes: [{
                    ticks: {
                        display: false
                    },
                    gridLines: {
                        display: false
                    },
                    display: false
                }],
                xAxes: [{
                    ticks: {
                        display: false
                    },
                    gridLines: {
                        display: false
                    },
                    display: false
                }]
            }
        }
    });
};

function initRadarChart(ctx, data, labels) {
    new Chart(ctx, {
        type: 'radar',
        data: {
            labels: labels,
            datasets: [{
                data: data,
                backgroundColor: 'rgba(90, 208, 96, 0.5)',
                borderColor: '#5AD060',
                pointBackgroundColor: '#5AD060',
                pointBorderColor: '#5AD060',
                borderWidth: 2
            }]
        },
        options: {
            legend: false,
            scale: {
                ticks: {
                    min: 0,
                    max: 5,
                    stepSize: 1,
                    display: false
                },
                pointLabels: {
                    fontColor: '#777',
                    fontSize: 12
                },
                gridLines: {
                    color: '#EEE'
                },
                angleLines: {
                    color: '#DDD'
                }
            },
            tooltips: false
        }
    });
}